import React from "react";
import SEO from "../components/SEO";
import CmsPageRenderer from "../components/CmsPageRenderer";
import PickupDeliveryCalculator from "../components/PickupDeliveryCalculator";
import ExtraPageBanner from "../components/ExtraPageBanner";
import { ToolPageCtaBand } from "../components/ToolPageCms";
import useExtraPageCms from "../hooks/useExtraPageCms";

const SLUG = "pickup-delivery";

function FallbackBody() {
  return (
    <>
      <SEO
        title="Pickup & Delivery Service in Nederland — Cargo ophalen en versturen | 5999Cargo"
        description="Laat uw pakketten, dozen, pallets of verhuiszending door 5999Cargo ophalen in heel Nederland en bezorgen vanaf onze hubs richting Curaçao en de Caribbean. Bereken vooraf de pickup-prijs met onze online calculator."
        keywords="pickup Nederland cargo, ophalen pakket Rotterdam, ophaalservice Caribbean, pickup calculator, vracht ophalen huis, zakelijke pickup pallets"
      />
      <ExtraPageBanner slug="pickup-delivery" testid="pickup-delivery-banner" />
      <PickupDeliveryCalculator />
    </>
  );
}

export default function PickupDeliveryPage() {
  const { data } = useExtraPageCms("pickup-delivery", null);
  return (
    <CmsPageRenderer
      slug={SLUG}
      testid="pickup-delivery-cms-driven"
      hideBlockTypes={["hero"]}
      topSection={<ExtraPageBanner slug="pickup-delivery" testid="pickup-delivery-banner" />}
      fallback={<FallbackBody />}
      extraSections={
        <>
          <PickupDeliveryCalculator />
          <ToolPageCtaBand cta={data?.cta_band} testid="pickup-delivery-cta-band" />
        </>
      }
    />
  );
}
